import { Portal, svgSprite } from '../../../hybrid/wrappers';
import React, { useEffect, useState, useRef, useContext, useMemo } from 'react';
import InfoMarker from '../InfoMarker/InfoMarker';
import ReactDOMServer from 'react-dom/server';
import '@tomtom-international/web-sdk-maps/dist/maps.css';
import UserContext from '../../../common/utils/getContext';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import PropTypes from 'prop-types';
import css from './TTMaps.module.scss';
import classnames from 'classnames';
import { useWidgetTranslates } from '../../../common/utils/utils';
import T from '../../../common/components/T';

const TTMaps = ({ onClick, contactData, bounds, center, funcs }) => {
    const mapElement = useRef();
    const [map, setMap] = useState(false);
    const [tt, setTT] = useState(false);
    const [markers, setMarkers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { lang } = useContext(UserContext) || {};
    const isMobile = useWindowDimensions() < 768;
    const [mapStyle, setMapStyle] = useState('basic_main');
    const [isFullscreen, setIsFullscreen] = useState(false);
    const locales = useMemo(
        () => ({
            fr: 'fr-FR',
            bg: 'bg-BG',
            zh: 'zh-CN',
            cs: 'cs-CZ',
            da: 'da-DK',
            nl: 'nl-NL',
            en: 'en-US',
            fi: 'fi-FI',
            ar: 'ar',
            de: 'de-DE',
            el: 'el-GR',
            hu: 'hu-HU',
            id: 'id-ID',
            it: 'it-TT',
            ko: 'ko-KR',
            lt: 'lt-LT',
            ms: 'ms-MY',
            nb: 'nb-NO',
            pl: 'pl-PL',
            pt: 'pt-PT',
            ru: 'ru-RU',
            sk: 'sk-SK',
            sl: 'sl-SI',
            es: 'es-ES',
            sv: 'sv-SE',
            th: 'th-TH',
            tr: 'tr-TR'
        }),
        []
    );
    useEffect(() => {
        (async () => {
            try {
                const tt = await import('@tomtom-international/web-sdk-maps');
                setTT(tt);
            } catch (e) {
                console.warn(e);
            }
        })();
    }, []);
    useEffect(() => {
        if (tt && mapElement.current) {
            let zoom = 4;
            if (bounds?.length) {
                switch (true) {
                    case bounds[0] > 200:
                        zoom = 1;
                        center[0] += 85;
                        break;
                    case bounds[0] > 100:
                        zoom = 2;
                        center[0] += 45;
                        break;
                    case bounds[0] > 30:
                        zoom = 3;
                        center[0] += 22;
                        break;
                }
            }
            let map = tt.map({
                key: '1piAH4WaagiEcMf1xzhLm7LgynYAUo8C',
                center: center || [50, 50],
                zoom: zoom,
                container: mapElement.current,
                language: locales[lang] || 'en-US',
                stylesVisibility: {
                    map: true
                },
                style: {
                    map: '2/basic_street-light'
                }
            });
            if (onClick) {
                map.on('click', onClick);
            }
            // map.addControl(new tt.FullscreenControl(), 'bottom-right');
            // map.addControl(new tt.NavigationControl(), 'bottom-right');
            setMap(map);
            return () => map.remove();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang, locales, onClick, tt]);

    const trans = useWidgetTranslates('map');
    useEffect(() => {
        for (const item of markers) {
            item.remove();
        }
        if (tt && map && contactData) {
            contactData.map((item) => {
                const { latitude, longitude } = item;
                let element = document.createElement('div');
                element.className = 'marker';
                element.innerHTML =
                    '<svg width="52" height="79" viewBox="0 0 52 79" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="26" cy="76.8055" rx="6.06667" ry="2.19444" fill="#1A1108"/><path d="M24.2667 52.6667H27.7333V75.5111C27.7333 76.4684 26.9573 77.2445 26 77.2445C25.0427 77.2445 24.2667 76.4684 24.2667 75.5111V52.6667Z" fill="#E25216"/><ellipse cx="26" cy="26.3333" rx="26" ry="26.3333" fill="#E25216"/><ellipse cx="26" cy="26.3333" rx="23.4" ry="23.7" stroke="url(#paint0_linear_4624_34290)"/><path d="M40.5046 30.0073C40.5046 30.0073 39.3084 38.7605 28.1039 41.4909C28.1438 41.4909 28.4229 30.3285 40.5046 30.0073Z" fill="white"/><path d="M40.5046 16.7169C40.5046 16.7169 30.935 18.8851 27.0273 30.0074C25.9906 33.9022 25.4323 37.8371 26.509 41.8524C26.509 41.8524 25.871 37.5159 29.4596 33.0188C33.0482 28.5217 41.0229 27.8793 41.0229 27.8793C41.0229 27.8793 42.6179 23.7034 40.5046 16.7169Z" fill="white"/><path d="M24.8741 41.8925C24.8741 41.8925 22.2026 29.927 29.978 21.8162C32.8887 18.885 37.0755 16.3554 37.0755 16.3554L35.0419 10.5333C35.0419 10.5333 27.1071 14.5084 23.8374 23.4624C20.5678 32.4164 23.7976 40.728 24.8741 41.8925Z" fill="white"/><path d="M25.6317 12.5008C26.3495 13.1432 26.8678 13.9864 27.0672 14.9099C27.5058 14.3879 27.8647 13.9463 28.1837 13.5849C27.3862 13.1834 26.509 12.822 25.6317 12.5008ZM26.1102 12.3402C27.1071 12.7015 28.3033 13.3038 28.383 13.344H28.4229C28.8216 12.9424 29.021 12.7417 29.021 12.7417C28.064 12.4606 27.1071 12.3402 26.1102 12.3402ZM26.8279 15.1508C26.6286 14.0266 25.9508 13.0629 24.9938 12.4205C24.4355 13.0228 23.9571 13.6652 23.5982 14.3879C23.2792 15.1508 23.04 15.9539 22.8805 16.7569C22.7609 17.2388 22.6811 17.6805 22.6412 18.1221C23.2393 18.2024 23.9172 18.2827 24.6349 18.363C25.3128 17.2388 26.0305 16.1948 26.8279 15.1508ZM22.6013 18.4032C22.5216 18.9653 22.4818 19.4471 22.402 19.8487C22.2425 21.1737 22.2026 22.2177 22.1229 23.1412V23.342H22.2026C22.2425 23.342 22.2824 23.3821 22.3222 23.3821C22.8805 21.7358 23.638 20.1297 24.5153 18.604C23.8374 18.604 23.1995 18.5237 22.6013 18.4032ZM22.2026 23.6632H22.1229C22.1229 23.8238 22.1229 23.9844 22.083 24.145C22.1229 23.9844 22.1627 23.8238 22.2026 23.6632C22.2425 23.6632 22.2425 23.6632 22.2026 23.6632ZM16.0222 15.713C14.4273 16.9577 13.0716 18.5237 12.1146 20.2903C12.2342 20.5714 13.0716 21.6555 16.3811 22.4987C16.6203 20.9729 17.0988 19.4873 17.7767 18.0819C17.8963 17.8411 18.0159 17.56 18.1754 17.2789C16.7798 16.6766 16.2215 16.0342 16.0222 15.713ZM18.4545 17.3994C18.295 17.6805 18.1754 17.9615 18.0558 18.2024C17.3779 19.6077 16.9393 21.0934 16.6602 22.6192C18.3747 22.9806 20.0893 23.2616 21.8039 23.342V23.1813C21.8437 22.2177 21.9235 21.1737 22.083 19.8487C22.1229 19.4471 22.1627 18.9653 22.2824 18.4032C21.0064 18.2024 19.7305 17.8812 18.4545 17.3994ZM21.8039 23.623C20.0494 23.5026 18.3349 23.2616 16.6203 22.8601C16.5406 23.342 16.5007 23.7836 16.4608 24.145C16.3013 25.4299 16.2615 26.7549 16.3412 28.0398C17.9361 28.2807 19.5311 28.4413 21.1659 28.5216C21.2855 27.3973 21.4849 26.2731 21.8039 25.1889C21.8039 25.1488 21.764 25.1488 21.764 25.1086C21.764 24.7473 21.764 24.2253 21.8039 23.623ZM21.0862 28.8428C19.4912 28.7625 17.8963 28.6019 16.3013 28.4012C16.3412 28.9231 16.3811 29.4451 16.4608 29.9671C16.5804 31.252 16.8595 32.5369 17.2184 33.7816C18.3349 33.9422 19.6108 34.0627 21.126 34.1831H21.1659C20.9666 32.4164 20.9266 30.6096 21.0862 28.8428ZM21.2057 34.4642C21.1659 34.5043 21.126 34.5043 21.0862 34.5043C19.6507 34.3839 18.3747 34.2634 17.2982 34.1028C17.5374 34.8256 17.8564 35.5082 18.1754 36.1908C18.6539 37.2347 19.2919 38.1984 20.0096 39.0817C20.9266 39.2022 21.8039 39.3226 22.402 39.3628C21.8437 37.7567 21.445 36.1105 21.2057 34.4642ZM22.5615 39.684C22.3621 39.6439 21.4849 39.5636 20.3684 39.4029C20.8469 39.9249 21.4051 40.4068 22.0431 40.8083C22.4418 41.0492 22.8805 41.2901 23.3191 41.4909C23.04 40.8484 22.8007 40.2462 22.5615 39.684ZM23.4786 41.8523H23.3988L23.2792 41.8121C22.8007 41.6113 22.3222 41.3704 21.8437 41.0894C21.126 40.6075 20.4482 40.0454 19.8501 39.3628C18.4944 39.2022 17.1785 38.9211 15.8627 38.5999C18.0558 40.4871 20.7273 41.6917 23.5583 42.1333C23.5583 42.0129 23.5185 41.9326 23.4786 41.8523ZM17.9361 36.3112C17.5773 35.5885 17.2583 34.8256 17.0191 34.0627C13.7095 33.5808 12.1146 32.9384 11.3969 32.5369C12.1146 34.4642 13.3108 36.1908 14.826 37.556L15.1849 37.9173C15.6235 38.3188 17.657 38.7203 19.571 39.0014C18.9728 38.1582 18.4146 37.2347 17.9361 36.3112ZM16.8994 33.7013C16.5406 32.4967 16.3013 31.252 16.1817 29.9671C16.102 29.405 16.0621 28.8428 16.0222 28.2807C12.4336 27.6784 10.9981 26.7951 10.4 26.233C10.4 26.6344 10.4 27.036 10.4 27.3973C10.4 27.4776 10.4 27.5178 10.4399 27.5981C10.4798 29.1239 10.719 30.6096 11.2374 32.0149C11.676 32.3762 13.0317 33.1392 16.8994 33.7013ZM11.9551 20.6116C11.1576 22.2578 10.6393 24.0246 10.4798 25.8314C10.7988 26.3132 11.995 27.3572 16.0222 28.0398C15.9425 26.7549 16.0222 25.4299 16.1418 24.145C16.1817 23.7435 16.2615 23.3018 16.3013 22.82C13.3108 22.0571 12.2741 21.0934 11.9551 20.6116ZM21.2855 13.9864C20.169 14.7895 19.252 15.8736 18.614 17.1183C19.8102 17.56 21.0463 17.8812 22.3222 18.0819C22.402 17.6805 22.4818 17.1986 22.5615 16.7168C22.721 15.8736 22.9602 15.0705 23.2792 14.2675C23.5982 13.6652 23.9969 13.0629 24.4754 12.5409C23.3589 12.822 22.2824 13.344 21.2855 13.9864ZM16.2615 15.5524C16.4209 15.7933 16.9393 16.3956 18.3747 16.9979C19.0127 15.713 19.9697 14.5887 21.126 13.7455C21.9235 13.2235 22.7609 12.7818 23.6779 12.4606C20.9666 12.8621 18.4146 13.9463 16.2615 15.5524Z" fill="white"/><defs><linearGradient id="paint0_linear_4624_34290" x1="26" y1="2.6333" x2="26" y2="50.0333" gradientUnits="userSpaceOnUse"><stop stop-color="white" stop-opacity="0.4"/><stop offset="1" stop-color="white" stop-opacity="0.12"/></linearGradient></defs></svg>';
                let marker = new tt.Marker({ element: element }).setLngLat([longitude, latitude]).addTo(map);
                if (isMobile) {
                    if (funcs?.onMarkerClick) {
                        marker.getElement().addEventListener('click', () => {
                            funcs?.onMarkerClick(item);
                        });
                    } else {
                        marker.getElement().addEventListener('click', () => {
                            setShowModal(item);
                        });
                    }
                }
                setMarkers((pre) => [...pre, marker]);
                const htmlString = ReactDOMServer.renderToStaticMarkup(<InfoMarker translates={trans} contactData={item} />);
                if (!isMobile) {
                    if (funcs?.onMarkerClick) {
                        marker.getElement().addEventListener('click', () => {
                            funcs?.onMarkerClick(item);
                        });
                    } else {
                        const markerHeight = 57,
                            markerRadius = 10,
                            linearOffset = 25;
                        marker.setPopup(
                            new tt.Popup({
                                offset: {
                                    top: [0, 0],
                                    'top-left': [0, 0],
                                    'top-right': [0, 0],
                                    bottom: [0, -markerHeight],
                                    'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
                                    'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
                                    left: [markerRadius, (markerHeight - markerRadius) * -1],
                                    right: [-markerRadius, (markerHeight - markerRadius) * -1]
                                }
                            }).setHTML(htmlString)
                        );
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactData, map, tt, trans, isMobile]);
    if (!tt) {
        return null;
    }
    return (
        <>
            <div
                id='map'
                className={classnames(css.googleMapWrapper)}
                style={onClick ? { cursor: 'pointer' } : {}}
                ref={mapElement}
            >
                <div className={css.toggleMap}>
                    <div
                        onClick={() => {
                            if (mapStyle !== 'basic_main') {
                                map.setStyle({
                                    map: 'basic_main'
                                });
                                setMapStyle('basic_main');
                            }
                        }}
                        className={classnames(css.toggleMapBtn, mapStyle === 'basic_main' && css.toggleMapBtnActive)}
                    >
                        <T textName='map' defaultStr='Карта' />
                    </div>
                    <div
                        onClick={() => {
                            if (mapStyle !== '2/basic_street-satellite') {
                                map.setStyle({
                                    map: '2/basic_street-satellite'
                                });
                                setMapStyle('2/basic_street-satellite');
                            }
                        }}
                        className={classnames(
                            css.toggleMapBtn,
                            mapStyle === '2/basic_street-satellite' && css.toggleMapBtnActive
                        )}
                    >
                        <T textName='satellite' defaultStr='Спутник' />
                    </div>
                </div>
                <div
                    onClick={() => {
                        if (isFullscreen) {
                            document.exitFullscreen().then(() => {
                                setIsFullscreen(false);
                            });
                        } else {
                            mapElement.current.requestFullscreen().then(() => {
                                setIsFullscreen(true);
                            });
                        }
                    }}
                    className={classnames('circleButton', css.fullScreenBtn)}
                >
                    {svgSprite(isFullscreen ? 'expand-min' : 'expand-max')}
                </div>
                <div className={css.zoomButtons}>
                    <div
                        onClick={() => {
                            const currentZoom = map.getZoom();
                            map.setZoom(currentZoom + 0.5);
                        }}
                        className={classnames('circleButton', css.zoomButton)}
                    >
                        {svgSprite('plus-gt')}
                    </div>
                    <div
                        onClick={() => {
                            const currentZoom = map.getZoom();
                            map.setZoom(currentZoom - 0.5);
                        }}
                        className={classnames('circleButton', css.zoomButton)}
                    >
                        {svgSprite('minus-gt')}
                    </div>
                </div>
            </div>
            {showModal && (
                <Portal closeHandler={() => setShowModal(false)}>
                    <div className={css.mainInfoContainerModal}>
                        <div className={css.mainInfoContainerModalContentWrap}>
                            <div
                                onClick={() => {
                                    setShowModal(false);
                                }}
                                className={css.modalWindowCloseBlock}
                            >
                                {svgSprite('cross', {
                                    className: css.modalWindowCloseIcon,
                                    fill: 'var(--greyExtraDarkColor)'
                                })}
                            </div>
                            <InfoMarker translates={trans} contactData={showModal} setShowModal={setShowModal} />
                        </div>
                    </div>
                </Portal>
            )}
        </>
    );
};
TTMaps.propTypes = {
    onClick: PropTypes.func,
    contactData: PropTypes.array,
    bounds: PropTypes.array,
    center: PropTypes.array
};
export default TTMaps;
